import { format } from "date-fns";
import {
    Box,
    Typography,
    Card,
    Stack,
    Chip,
    Divider,
    CircularProgress,
    Alert,
    List,
    ListItemButton,
    ListItemText,
} from "@mui/material";
import { CheckCircle, ChevronRight } from "@mui/icons-material";


const SESSION_STATUS = {
    active: { label: "Active",     color: "success" },
    closed: { label: "Closed",     color: "default" },
    none:   { label: "No session", color: "warning" },
};

const FlightList = ({ 
    crewFlights, 
    loading, 
    getFlightSession, 
    onOpenDetail 
}) => {
    if (loading) return (
        <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
            <CircularProgress size={24} />
        </Box>
    );

    if (!crewFlights?.length) return (
        <Alert 
            severity="info"
            sx={{ alignItems: "center" }}
        >
            No flights found in the selected date range.
        </Alert>
    );

    return (
        <Box display="flex" flexDirection="column" gap={1}>
            <Typography variant="subtitle1" fontWeight={600}>
                My Flights
            </Typography>
            <Card variant="outlined">
                <List disablePadding>
                    {crewFlights.map((flight, idx) => {
                        const fs = getFlightSession(flight);
                        const status = fs ? SESSION_STATUS[fs.status] || SESSION_STATUS.active : SESSION_STATUS.none;
                        const isActive = fs?.status === "active";

                        return (
                            <Box key={`${flight.flightDesc}-${flight.dep}-${flight.flightDate}`}>
                                {idx > 0 && <Divider />}
                                <ListItemButton onClick={() => onOpenDetail(flight)} sx={{ py: 1.25, px: 2 }}>
                                    <ListItemText
                                        disableTypography
                                        primary={
                                            <Stack direction="row" alignItems="center" flexWrap="wrap" spacing={1}>
                                                <Typography variant="body2">{flight.flightDesc}</Typography>
                                                <Typography variant="body2">{flight.dep}-{flight.arr}</Typography>
                                                <Typography variant="body2">{flight.acType || ""}</Typography>
                                                <Typography variant="body2">{flight.flightReg || ""}</Typography>
                                            </Stack>
                                        }
                                        secondary={
                                            <Stack direction="row" alignItems="center" justifyContent="space-between" mt={0.25}>
                                                <Box display="flex" gap={1}>
                                                    {flight.flightDate && (
                                                        <Typography variant="body2" color="text.secondary">
                                                            {format(new Date(flight.flightDate), "dd/MM/yyyy")}
                                                        </Typography>
                                                    )}
                                                    <Typography variant="body2" color="text.secondary">
                                                        {flight.etd || flight.std || ""} - {flight.eta || flight.sta || ""}
                                                    </Typography>
                                                </Box>
                                            </Stack>
                                        }
                                    />
                                    <Chip
                                        label={status.label}
                                        color={status.color}
                                        size="small"
                                        icon={isActive ? <CheckCircle /> : undefined}
                                        variant={fs ? "filled" : "outlined"}
                                        sx={{ fontSize: "0.68rem", height: 20 }}
                                    />
                                    <ChevronRight fontSize="small" sx={{ color: "text.disabled", ml: 1 }} />
                                </ListItemButton>
                            </Box>
                        );
                    })}
                </List>
            </Card>
        </Box>
    );
};

export default FlightList;
